<template>
  <el-dialog title="添加内部备注" :visible.sync="formVisible" width="620px" :close-on-click-modal="false">
    <el-form ref="dataForm" :model="form" :rules="formRules" label-width="90px" size="small">
      <el-form-item label="反馈编号">
        <el-input :value="row.complaintNo" readonly />
      </el-form-item>
      <el-form-item label="内部备注" prop="content">
        <el-input type="textarea" :rows="5" maxlength="500" show-word-limit v-model="form.content" placeholder="请输入内部备注（仅内部可见，客户看不到）" />
      </el-form-item>
      <el-form-item label="备注图片">
        <more-image-upload v-model="imageList" :limit="9" hintText="选填，最多 9 张" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="formVisible = false">取消</el-button>
      <el-button type="primary" size="small" @click="doCreate()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import customerComplaintApi from '@/api/complaint/customerComplaint'
import MoreImageUpload from '@/components/MoreImageUpload'
import { STATE_ARCHIVED } from '../complaintState'

export default {
  name: 'ComplaintRemark',
  components: { MoreImageUpload },
  data() {
    return {
      formVisible: false,
      isRepSub: false,
      row: {},
      imageList: [],
      form: {
        id: null,
        content: null,
        images: null
      },
      formRules: {
        content: [{ required: true, message: '请输入内部备注', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleRemark(row) {
      // 已归档不允许再加备注，列表按钮本身也是置灰的，这里再兜一层
      if (+row.state === STATE_ARCHIVED) {
        this.$common.showMsg('warning', '该客诉已归档，不能再添加备注')
        return
      }
      this.row = row || {}
      this.imageList = []
      this.form = { id: row.id, content: null, images: null }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return
        if (this.isRepSub) return
        this.isRepSub = true
        const params = {
          ...this.form,
          // 多图统一按英文逗号拼接的字符串传，跟 customer_order_after.voucher_url 一致
          images: (this.imageList || []).map(f => f.url).filter(u => !!u).join(',')
        }
        customerComplaintApi.remark(params)
          .then(() => {
            this.$message.success('操作成功')
            this.formVisible = false
            this.$emit('created')
          })
          .finally(() => {
            this.isRepSub = false
          })
      })
    }
  }
}
</script>
